import { OperativeUnitDto } from "@/core/features/operative-units/operative-unit.dto";
import { Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class OperativeUnitWithAllocationCostDto extends OperativeUnitDto {
  @Transform(({ value }) => toEuros(value))
  userCost: number;

  @Transform(({ value }) => toEuros(value))
  dietCost: number;

  @Transform(({ value }) => toEuros(value))
  vehicleCost: number;

  @Transform(({ value }) => toEuros(value))
  onCallCost: number;

  @Transform(({ value }) => toEuros(value))
  totalCost: number;
}
